<template>
  <section class="section">
    <chainEdit
      @chain-update-complete="goBack"
      @chain-update-cancelled="goBack"
      :id="id"
    />
  </section>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import routerUtils from "@/utils/routerUtils";
import chainEdit from "@/components/chainEdit.vue";

export default defineComponent({
  props: {
    id: {
      type: Number,
      required: false,
    },
    returnTo: {
      type: String,
      default: "/chains/admin",
    },
  },
  components: {
    chainEdit,
  },

  methods: {
    goBack(): void {
      routerUtils.moveTo(this.returnTo);
    },
  },
});
</script>
